<template>
    <div class="countdown" v-show="!dateFinish">
        {{time}}
    </div>
    

</template>

<script>

export default {
    props: ['dataCountDown'],
    data() {
        return {
            dateFinish: false,
            time: '',
            launchDate: new Date(this.dataCountDown).getTime()
        }
    },
    methods: {
        countDownTimer() {

            const now = new Date().getTime();
            const t = this.launchDate - now;

            if( t > 0) {
                setTimeout(() => {

                    //algorithm to calculate days
                    let days = Math.floor(t/ (1000 * 60 * 60 * 24));
                    //prefix any number below 10 with a "0"
                    if (days < 10) { days = '0' + days; }

                    //algorithm to calculate hours
                    let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    //prefix any number below 10 with a "0"
                    if (hours < 10) { hours = '0' + hours; }

                    //algorithm to calculate minuts
                    let min = Math.floor((t % (1000 * 60 * 60 )) / (1000 * 60));
                    //prefix any number below 10 with a "0"
                    if (min < 10) { min = '0' + min; }

                    //algorithm to calculate seconds
                    let sec = Math.floor((t % (1000 * 60 )) / 1000);
                    //prefix any number below 10 with a "0"
                    if (sec < 10) { sec = '0' + sec; }

                    this.time = `${days} Días : ${hours} Horas : ${min} Minutos : ${sec} Segundos para empezar el evento`
                    
                    this.countDownTimer()
                }, 1000)
            }else{
                //para no ver nada
                // this.dateFinish = true;

                //para poner texto
                this.time = `Disfruta del evento`
            }
        }
    },
    created() {
        this.countDownTimer()
    }
    
}
</script>

<style scoped>

*{
    font-family: 'Open Sans Bold';
    font-weight: bold;
    color: #5f579A;
}

</style>